import React, { useEffect } from "react";
import { Table } from "antd";
import { ColumnsType } from "antd/es/table";
import { useRemainingModel } from "../remainingModel";
import { IRemainingDetail } from "../remainingService";


export function DataTable() {
    const {
        dataSource, selectedRowKeys, pgCfg,
        loadData, setSelectedRowKeys
    } = useRemainingModel();

    useEffect(() => {
        loadData()
    }, [])

    const columns: ColumnsType<IRemainingDetail> = [
        {
            title: '序号',
            width: 40,
            fixed: "left",
            render: (t, r, i) => i + 1
        }, {
            title: '门店编码',
            width: 160,
            dataIndex: 'shopCode',
            fixed: "left",
        }, {
            title: '门店名称',
            width: 160,
            dataIndex: 'shopName',
            fixed: "left",
        }, {
            title: '客户、供应商编码',
            width: 120,
            dataIndex: 'partnerCode',
        }, {
            title: '客户、供应商名称',
            width: 160,
            dataIndex: 'partnerName',
        }, {
            title: '客户剩余金额',
            width: 120,
            dataIndex: 'remainingAmount',
        }, {
            title: '客户充值金额',
            width: 120,
            dataIndex: 'rechAmount',
        }, {
            title: '客户核销账单金额',
            width: 120,
            dataIndex: 'billAmount',
        }, {
            title: '客户应该剩余金额',
            width: 120,
            dataIndex: 'remainingAmount2',
        }, {
            title: '差异金额',
            width: 100,
            dataIndex: 'diffAmount',
        }
    ];


    // //点击行选高亮
    // const onRow = (id: string) => {
    //     if (selectedRowKeys.length > 0 && selectedRowKeys[0] === id) {
    //         setSelectedRowKeys([]);
    //     } else {
    //         setSelectedRowKeys([id]);
    //     }
    // };

    return (
        <Table
            rowKey={record => record.id}
            // rowSelection={{
            //     type: "radio",
            //     selectedRowKeys: selectedRowKeys, //记录选中
            //     onChange: (selectedRowKeys: React.Key[], selectedRows: IRemainingDetail[]) => {
            //         setSelectedRowKeys(selectedRowKeys as string[]);
            //     }
            // }}
            columns={columns}
            dataSource={dataSource}
            pagination={{
                ...pgCfg,
                showTotal: (total: number) => `共${total}条`,
                position: ["bottomCenter"],
                onChange: (pageNum, pageSize) => {
                    loadData({ pageNum, pageSize })
                }
            }}
            // onRow={record => ({
            //     onClick: () => onRow(record.id)
            // })}
            scroll={{ x: 'max-content' }}
        />
    )
}
